



























































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import {
    DEFAULT_NETWORK_ID,
    DEFAULT_NETWORK,
    DEFAULT_NETWORK_NAME,
} from '@/store/modules/network/network'

import Supply from '@/components/Home/TopInfo/Supply.vue'
import Validators from '@/components/Home/TopInfo/Validators.vue'
import Stake from '@/components/Home/TopInfo/Stake.vue'
import ValidatorsHistory from '@/components/Home/TopInfo/ValidatorsHistory.vue'
import Fees from '@/components/ActionChain/Infos/Fees.vue'
import Price from '@/components/ActionChain/Infos/Price.vue'
import MarketCap from '@/components/ActionChain/Infos/MarketCap.vue'
import moment from 'moment'
import { ICurrentValidatorRes } from '@/services/currentValidator/model'
import ValidatorDataTable from '@/components/Validators/ValidatorDataTable.vue'

@Component({
    components: {
        Supply,
        Validators,
        Stake,
        ValidatorsHistory,
        Fees,
        Price,
        MarketCap,
        ValidatorDataTable,
    },
})
export default class Home extends Vue {
    netID = DEFAULT_NETWORK_ID.toString()
    validator_initial = ''

    get selectedNet() {
        return this.$store.state.Network.selectedNetwork
    }

    @Watch('selectedNetId')
    currentNetID() {
        if (this.selectedNet) this.netID = this.selectedNet.networkId
        else this.netID = DEFAULT_NETWORK_ID.toString()
    }

    get _actChainID() {
        return DEFAULT_NETWORK.actChainId
    }

    get _astChainID() {
        return DEFAULT_NETWORK.astChainId
    }

    get _athChainID() {
        return DEFAULT_NETWORK.athChainId
    }

    get actChainURL() {
        return `/action?network=${DEFAULT_NETWORK_NAME}`
    }

    get astChainURL() {
        return `/blockchain/${this._astChainID}?network=${DEFAULT_NETWORK_NAME}`
    }

    get athChainURL() {
        return `/blockchain/${this._athChainID}?network=${DEFAULT_NETWORK_NAME}`
    }
    get currentValidators() {
        const validators: ICurrentValidatorRes = this.$root.$store.state.Metrics
            .currentValidators
        let startDate = 10000000000
        if (!validators) return null
        const data = this.$root.$store.state.Metrics.currentValidators
            .validators
        data.map((x: any) => {
            if (x.startTime < startDate) {
                startDate = x.startTime
            }
        })
        //  Changing initial month for Graph mapping.
        // getting initial startdate of validator and subtracting month by 1 so that graph can be mapped evenly.
        const month = Number(moment.unix(startDate).format('MM')) - 1
        let date = moment
            .unix(startDate)
            .format(`YYYY-${month < 10 ? '0' + month : month}-DD`)
        date = date + 'T00:00:00Z'
        this.validator_initial = date
        return validators.validators
    }
}
